import {MERGED} from "../../../Constants/StatusConstants";
import {useAlert} from "../../alerts/AlertContext";
import {Link} from "react-router-dom";
import * as React from "react";
import PropTypes from "prop-types";
import TaskEditMenu from './../TaskEditMenu';


function TaskIdLinkView(props){
    const showAlert = useAlert();

    const id = props.id;
    const statusId = props.statusId;    
    const mergeStatus = props.mergeStatus;

    return (
        <TaskEditMenu taskId={id} statusId={statusId}>id</TaskEditMenu>
    )
}
TaskIdLinkView.propTypes = {
    id: PropTypes.string.isRequired,
    mergeStatus: PropTypes.string.isRequired,
}

export default TaskIdLinkView;